// Import model
import { DataviewObjectFileResponse } from '../models/DataviewObjectFileResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterObjectFileRequest } from '../models/FilterObjectFileRequest';
import { ObjectFile } from '../models/ObjectFile';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterObjectFileRequestSerializer } from './FilterObjectFileRequestSerializer';
import { ObjectFileSerializer } from './ObjectFileSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewObjectFileResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewObjectFileResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewObjectFileResponse instance
   */
  static deserialize(json: string): DataviewObjectFileResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewObjectFileResponse instance
   */
  static fromObject(obj: any): DataviewObjectFileResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewObjectFileResponse');
    }


    const instance: DataviewObjectFileResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ObjectFileSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterObjectFileRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewObjectFileResponse instances
   */
  static deserializeArray(json: string): DataviewObjectFileResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewObjectFileResponse instance to a JSON string
   */
  static serialize(instance: DataviewObjectFileResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewObjectFileResponse instance to a plain object
   */
  static toObject(instance: DataviewObjectFileResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ObjectFileSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterObjectFileRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewObjectFileResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewObjectFileResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
